export const SET_AGGREGATION = 'aggregations/SET_AGGREGATION';
